import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

// A4 Print Layout Component
export function A4PrintLayout({ limaDeliveries, provinciaDeliveries }) {
  const allDeliveries = [
    ...limaDeliveries.map(d => ({ ...d, type: 'lima' })),
    ...provinciaDeliveries.map(d => ({ ...d, type: 'provincia' }))
  ];

  const pages = [];
  for (let i = 0; i < allDeliveries.length; i += 8) {
    const pageDeliveries = allDeliveries.slice(i, i + 8);
    pages.push(
      <div
        key={`page-${i}`}
        style={{
          width: '210mm',
          height: '297mm',
          pageBreakAfter: i + 8 < allDeliveries.length ? 'always' : 'auto',
          fontFamily: 'Montserrat, sans-serif',
          padding: '8mm',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: 'repeat(4, 1fr)',
          gap: '6mm',
          width: '100%',
          height: '100%'
        }}>
          {pageDeliveries.map((dp) => (
            dp.type === 'lima' ? (
              <LimaLabelA4 key={`lima-${dp.id}`} dp={dp} />
            ) : (
              <ProvinciaLabelA4 key={`provincia-${dp.id}`} dp={dp} />
            )
          ))}
        </div>
      </div>
    );
  }
  return <>{pages}</>;
}

// Lima Label for A4
function LimaLabelA4({ dp }) {
  return (
    <div
      style={{
        border: '2px solid #B1336E',
        padding: '4mm',
        boxSizing: 'border-box',
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: '3mm',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <p style={{ 
        color: '#B1336E', 
        fontSize: '18px', 
        fontWeight: 'bold',
        margin: '0 0 2mm 0'
      }}>
        ID: {dp.id}
      </p>
      <p style={{ 
        color: '#1e293b', 
        fontSize: '13px',
        fontWeight: '600',
        margin: '0 0 1.5mm 0',
        lineHeight: '1.2'
      }}>
        {dp.recipient_name}
      </p>
      {dp.product && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          margin: '0 0 1.5mm 0',
          lineHeight: '1.2'
        }}>
          {dp.product}
        </p>
      )}
      {dp.district && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          fontWeight: '500',
          margin: '0 0 1.5mm 0',
          lineHeight: '1.2'
        }}>
          {dp.district}
        </p>
      )}
      <p style={{ 
        color: '#475569', 
        fontSize: '9px',
        margin: '0',
        paddingRight: '28mm',
        lineHeight: '1.3'
      }}>
        {dp.address}
      </p>
      <div style={{
        position: 'absolute',
        bottom: '4mm',
        right: '4mm',
        padding: '1.5mm',
        backgroundColor: 'white',
        borderRadius: '2mm'
      }}>
        <QRCodeCanvas
          value={dp.tracking_code}
          size={75}
          level="H"
          includeMargin={false}
        />
      </div>
    </div>
  );
}

// Provincia Label for A4
function ProvinciaLabelA4({ dp }) {
  return (
    <div
      style={{
        border: '2px solid #E6B43C',
        padding: '4mm',
        boxSizing: 'border-box',
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: '3mm',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2mm'
      }}>
        <p style={{ 
          color: '#E6B43C', 
          fontSize: '18px', 
          fontWeight: 'bold',
          margin: '0'
        }}>
          ID: {dp.id}
        </p>
        <p style={{
          color: '#E6B43C',
          fontSize: '10px',
          fontWeight: 'bold',
          margin: '0'
        }}>
          PROVINCIA
        </p>
      </div>
      <p style={{ 
        color: '#1e293b', 
        fontSize: '13px',
        fontWeight: '600',
        margin: '0 0 1mm 0',
        lineHeight: '1.2'
      }}>
        {dp.recipient_name}
      </p>
      {dp.recipient_dni && (
        <p style={{ 
          color: '#475569', 
          fontSize: '9px',
          margin: '0 0 1.5mm 0'
        }}>
          DNI: {dp.recipient_dni}
        </p>
      )}
      {dp.product && (
        <p style={{ 
          color: '#475569', 
          fontSize: '9px',
          margin: '0 0 1.5mm 0',
          lineHeight: '1.2'
        }}>
          {dp.product}
        </p>
      )}
      <p style={{ 
        color: '#475569', 
        fontSize: '10px',
        fontWeight: '600',
        margin: '0 0 1mm 0'
      }}>
        {dp.province} - {dp.district}
      </p>
      <p style={{ 
        color: '#475569', 
        fontSize: '8px',
        margin: '0 0 1mm 0',
        lineHeight: '1.2'
      }}>
        {dp.address}
      </p>
      <p style={{ 
        color: '#E6B43C', 
        fontSize: '8px',
        fontWeight: '600',
        margin: '0',
        lineHeight: '1.2'
      }}>
        Agencia: {dp.agency_address}
      </p>
      {dp.tracking_code && <div style={{ marginTop: '2mm', textAlign: 'center' }}><QRCodeCanvas value={dp.tracking_code} size={64} marginSize={2} /></div>}
    </div>
  );
}

// Thermal Print Layout Component
export function ThermalPrintLayout({ limaDeliveries, provinciaDeliveries }) {
  const allDeliveries = [
    ...limaDeliveries.map(d => ({ ...d, type: 'lima' })),
    ...provinciaDeliveries.map(d => ({ ...d, type: 'provincia' }))
  ];

  return (
    <div style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {allDeliveries.map((dp, index) => (
        dp.type === 'lima' ? (
          <LimaLabelThermal 
            key={`lima-${dp.id}`} 
            dp={dp} 
            isLast={index === allDeliveries.length - 1}
          />
        ) : (
          <ProvinciaLabelThermal 
            key={`provincia-${dp.id}`} 
            dp={dp}
            isLast={index === allDeliveries.length - 1}
          />
        )
      ))}
    </div>
  );
}

// Lima Label for Thermal
function LimaLabelThermal({ dp, isLast }) {
  return (
    <div
      style={{
        width: '80mm',
        minHeight: '60mm',
        border: '2px solid #B1336E',
        padding: '4mm',
        boxSizing: 'border-box',
        backgroundColor: 'white',
        marginBottom: '5mm',
        pageBreakAfter: isLast ? 'auto' : 'always',
        pageBreakInside: 'avoid',
        borderRadius: '3mm'
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '3mm' }}>
        <QRCodeCanvas
          value={dp.tracking_code}
          size={80}
          level="H"
          includeMargin={false}
        />
      </div>
      <p style={{ 
        color: '#B1336E', 
        fontSize: '18px', 
        fontWeight: 'bold',
        margin: '0 0 2mm 0',
        textAlign: 'center'
      }}>
        ID: {dp.id}
      </p>
      <p style={{ 
        color: '#1e293b', 
        fontSize: '13px',
        fontWeight: '600',
        margin: '0 0 2mm 0'
      }}>
        {dp.recipient_name}
      </p>
      {dp.product && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          margin: '0 0 1mm 0'
        }}>
          {dp.product}
        </p>
      )}
      {dp.district && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          fontWeight: '500',
          margin: '0 0 1mm 0'
        }}>
          {dp.district}
        </p>
      )}
      <p style={{ 
        color: '#475569', 
        fontSize: '9px',
        margin: '0'
      }}>
        {dp.address}
      </p>
    </div>
  );
}

// Provincia Label for Thermal
function ProvinciaLabelThermal({ dp, isLast }) {
  return (
    <div
      style={{
        width: '80mm',
        minHeight: '70mm',
        border: '2px solid #E6B43C',
        padding: '4mm',
        boxSizing: 'border-box',
        backgroundColor: 'white',
        marginBottom: '5mm',
        pageBreakAfter: isLast ? 'auto' : 'always',
        pageBreakInside: 'avoid',
        borderRadius: '3mm'
      }}
    >
      <div style={{
        textAlign: 'center',
        marginBottom: '3mm',
        borderBottom: '1px solid #E6B43C',
        paddingBottom: '2mm'
      }}>
        <p style={{
          color: '#E6B43C',
          fontSize: '14px',
          fontWeight: 'bold',
          margin: '0 0 1mm 0'
        }}>
          ENVÍO A PROVINCIA
        </p>
        <p style={{ 
          color: '#E6B43C', 
          fontSize: '18px', 
          fontWeight: 'bold',
          margin: '0'
        }}>
          ID: {dp.id}
        </p>
      </div>
      <p style={{ 
        color: '#1e293b', 
        fontSize: '13px',
        fontWeight: '600',
        margin: '0 0 1mm 0'
      }}>
        {dp.recipient_name}
      </p>
      {dp.recipient_dni && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          margin: '0 0 2mm 0'
        }}>
          DNI: {dp.recipient_dni}
        </p>
      )}
      {dp.product && (
        <p style={{ 
          color: '#475569', 
          fontSize: '10px',
          margin: '0 0 2mm 0'
        }}>
          {dp.product}
        </p>
      )}
      <p style={{ 
        color: '#1e293b', 
        fontSize: '11px',
        fontWeight: '600',
        margin: '0 0 1mm 0'
      }}>
        {dp.province} - {dp.district}
      </p>
      <p style={{ 
        color: '#475569', 
        fontSize: '9px',
        margin: '0 0 2mm 0'
      }}>
        {dp.address}
      </p>
      <div style={{
        backgroundColor: '#FFF9E6',
        padding: '2mm',
        borderRadius: '2mm',
        border: '1px solid #E6B43C'
      }}>
        <p style={{ 
          color: '#E6B43C', 
          fontSize: '8px',
          fontWeight: '600',
          margin: '0',
          lineHeight: '1.3'
        }}>
          Agencia: {dp.agency_address}
        </p>
      </div>
      {dp.tracking_code && <div style={{ marginTop: '2mm', textAlign: 'center' }}><QRCodeCanvas value={dp.tracking_code} size={64} marginSize={2} /></div>}
    </div>
  );
}


